import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/Awards.css";

import award1 from "../assets/img/awards/ASOCHM National Education Excellence Award 2017.webp";
import award2 from "../assets/img/awards/ASSOCHM Education Excellence Award 2019.webp";
import award3 from "../assets/img/awards/award 1.webp";
import award4 from "../assets/img/awards/award 2.webp";
import award5 from "../assets/img/awards/award 3.webp";
import award6 from "../assets/img/awards/award 9.webp";
import award7 from "../assets/img/awards/award 10.webp";
import award8 from "../assets/img/awards/Best Emerging Private University Awards.webp";
import award9 from "../assets/img/awards/Best Emerging University.webp";
import award10 from "../assets/img/awards/Best University in Central India for Placement 2023.webp";
import award11 from "../assets/img/awards/Best Upcomming University Award 2024.webp";
import award12 from "../assets/img/awards/CEGR Best Private University 2022.webp";
import award13 from "../assets/img/awards/Center for Education Growth and Education 2023.webp";
import award14 from "../assets/img/awards/Certificate for  Outstanding Academic Excellence Award.webp";
import award16 from "../assets/img/awards/Education Excellence Award 2024.webp";
import award17 from "../assets/img/awards/nayabharat.webp";
import award18 from "../assets/img/awards/sushiksha chttisgardh 2018.webp";
import award19 from "../assets/img/awards/Year 2022 - Certificate of Excellence – Best University for Pharmaceutical Studies..webp";
import award20 from "../assets/img/awards/Year 2024 – Dr. A.P.J. Abdul Kalam Inspiration Award for Best Private University in India.webp";
import award21 from "../assets/img/awards/year 2024 -Education Excellence Award – ISBM University, Chhattisgarh, 2024.webp";


const awards = [
  {
    year: "2024",
    category: "National University Excellence",
    title: "Dr. A.P.J. Abdul Kalam Inspiration Award – Best Private University in India",
    organisation: "Topnotch Foundation",
    description:
      "Presented to ISBM University as the Best Private University in India at the Dr. A.P.J. Abdul Kalam Inspiration Awards 2024.",
    image: award20,
    theme: "indigo",
  },
  {
    year: "2024",
    category: "Education Excellence",
    title: "Education Excellence Award",
    organisation: "LEO1",
    description:
      "Presented to ISBM University, Chhattisgarh, for its continued commitment to educational excellence and institutional progress.",
    image: award21,
    theme: "blue",
  },
  {
    year: "2024",
    category: "Emerging University",
    title: "Best Upcoming University Award",
    organisation: "World Education Summit and Awards",
    description:
      "Recognising ISBM University as a promising institution demonstrating academic growth, innovation and educational leadership.",
    image: award11,
    theme: "indigo",
  },
  {
    year: "2024",
    category: "Individual Education Honour",
    title: "Education Excellence Award",
    organisation: "COER University, Roorkee",
    description:
      "Presented to Prof. (Dr.) Anand Mahalwar for remarkable achievements and exceptional contributions to education.",
    image: award16,
    theme: "gold",
  },
  {
    year: "2024",
    category: "National Development",
    title: "Naya Bharat Utsav Recognition",
    organisation: "Naya Bharat Utsav 2024",
    description:
      "Presented to ISBM University for participation in the national development exhibition commemorating ten years of progress.",
    image: award17,
    theme: "amber",
  },
  {
    year: "2023",
    category: "Placement Excellence",
    title: "Best University in Central India for Placement",
    organisation: "Centre for Education Growth and Research",
    description:
      "Awarded for outstanding contribution to education, skill development, research and student placement outcomes.",
    image: award10,
    theme: "gold",
  },
  {
    year: "2023",
    category: "Placement Excellence",
    title: "Best Private University in Central India for Placement",
    organisation: "Centre for Education Growth and Research",
    description:
      "Recognised during the Rashtriya Shiksha Gaurav Puraskar Ceremony for excellence in placement and education.",
    image: award13,
    theme: "ruby",
  },
  {
    year: "2023",
    category: "Individual Academic Honour",
    title: "Outstanding Academic Excellence Award",
    organisation: "Apollo College of Pharmacy, Durg",
    description:
      "Presented to Prof. Anand Mahalwar for exceptional dedication, academic contribution and commitment to teaching.",
    image: award14,
    theme: "blue",
  },
  {
    year: "2022",
    category: "Private University Excellence",
    title: "Best Private University in Chhattisgarh",
    organisation: "Centre for Education Growth and Research",
    description:
      "Awarded for outstanding contribution to education, skill development and research.",
    image: award12,
    theme: "crimson",
  },
  {
    year: "2022",
    category: "Pharmaceutical Education",
    title: "Best University for Pharmaceutical Studies",
    organisation: "Indo-UK Global Business Awards",
    description:
      "Recognised through a Certificate of Excellence for significant contribution to pharmaceutical studies.",
    image: award19,
    theme: "gold",
  },
  {
    year: "2019",
    category: "Digital Education",
    title: "Emerging University Promoting Government Digital Initiatives",
    organisation: "ASSOCHAM Edushine Excellence Awards",
    description:
      "Recognised for promoting government digital initiatives and advancing technology-enabled education.",
    image: award2,
    theme: "amber",
  },
  {
    year: "2019",
    category: "Higher Education Excellence",
    title: "Certificate of Excellence in Higher Education",
    organisation: "11th Higher Education & Human Resource Conclave",
    description:
      "Awarded to ISBM University, Chhattisgarh, for exemplary contribution to higher education.",
    image: award6,
    theme: "blue",
  },
  {
    year: "2019",
    category: "Digital Education",
    title: "ASSOCHAM National Education Summit Recognition",
    organisation: "12th ASSOCHAM National Education Summit",
    description:
      "Presented at the Edushine Excellence Awards for advancing digital initiatives and educational innovation.",
    image: award7,
    theme: "amber",
  },
  {
    year: "2018",
    category: "Innovation in Education",
    title: "Most Innovative University",
    organisation: "News18 Madhya Pradesh–Chhattisgarh",
    description:
      "Recognised at the Sushiksha Chhattisgarh Awards for an innovative approach to higher education.",
    image: award18,
    theme: "crimson",
  },
  {
    year: "2017",
    category: "National Recognition",
    title: "Best Upcoming Private University",
    organisation: "ASSOCHAM National Education Excellence Awards",
    description:
      "Recognised for building a progressive academic environment focused on quality, innovation and career-oriented learning.",
    image: award1,
    theme: "indigo",
  },
  {
    year: "Recognition",
    category: "Academic Excellence",
    title: "Award for Excellence in Education",
    organisation: "Education Excellence Recognition",
    description:
      "Presented in recognition of contribution to quality education, academic development and student success.",
    image: award3,
    theme: "ruby",
  },
  {
    year: "Recognition",
    category: "Institutional Achievement",
    title: "Certificate of Institutional Excellence",
    organisation: "Education Leadership Recognition",
    description:
      "Recognising commitment to institutional development, innovative learning and academic quality.",
    image: award4,
    theme: "blue",
  },
  {
    year: "Recognition",
    category: "University Achievement",
    title: "Award for Outstanding Educational Contribution",
    organisation: "Higher Education Recognition",
    description:
      "Honouring the University’s contribution to accessible education and learner development.",
    image: award5,
    theme: "crimson",
  },
  {
    year: "Recognition",
    category: "Emerging University",
    title: "Best Emerging Private University in Chhattisgarh",
    organisation: "Education Media Recognition",
    description:
      "Recognised for academic progress, institutional development and contribution to higher education.",
    image: award8,
    theme: "ruby",
  },
  {
    year: "Winner",
    category: "National Education Award",
    title: "Better India Education Award",
    organisation: "India Today",
    description:
      "A national recognition celebrating educational advancement, innovation and institutional impact.",
    image: award9,
    theme: "gold",
  },
];

function Awards() {
  const mainSliderRef = useRef(null);
  const browserSliderRef = useRef(null);
  const [activeAward, setActiveAward] = useState(0);

  const mainSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 700,
    fade: true,
    cssEase: "cubic-bezier(.22,.61,.36,1)",
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipe: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => setActiveAward(next),
  };

  const browserSettings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: false,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const getVisibleSlides = () => {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return 2;
      if (window.innerWidth <= 1200) return 3;
      return 4;
    };

    const visibleSlides = getVisibleSlides();

    const safePosition = Math.min(
      activeAward,
      Math.max(0, awards.length - visibleSlides)
    );

    browserSliderRef.current?.slickGoTo(safePosition);
  }, [activeAward]);

  const openAward = (index) => {
    setActiveAward(index);
    mainSliderRef.current?.slickGoTo(index);
  };

  return (
    <section className="awards-section" aria-labelledby="awards-heading">
      <div className="awards-glow awards-glow-left" aria-hidden="true" />
      <div className="awards-glow awards-glow-right" aria-hidden="true" />

      <div className="container mx-auto">
        <header className="awards-header">
          <div className="awards-heading-wrap">
            <span className="awards-eyebrow">
              <i />
              Awards &amp; Recognition
            </span>
            <h2 id="awards-heading">
              Celebrating the
              <em> Impact Of Excellence</em>
            </h2>
          </div>

          <div className="awards-introduction">
            <p>
              Our recognitions reflect an enduring commitment to academic
              excellence, innovation and creating meaningful opportunities for
              every learner.
            </p>
            <div className="awards-total">
              <strong>{String(awards.length).padStart(2, "0")}</strong>
              <span>
                Distinguished
                <br />
                recognitions
              </span>
            </div>
          </div>
        </header>

        <div className="award-main-slider">
          <Slider ref={mainSliderRef} {...mainSettings}>
            {awards.map((award, index) => (
              <div key={`${award.title}-${index}`}>
                <div
                  className={`award-showcase award-theme-${award.theme}`}
                  aria-hidden={activeAward !== index}
                >
                  <div className="award-visual">
                    <span className="award-watermark" aria-hidden="true">
                      {award.year}
                    </span>
                    <div className="award-image-halo" aria-hidden="true" />
                    <div className="award-image-frame">
                      <img
                        src={award.image}
                        alt={`${award.title} – ${award.organisation}`}
                      />
                    </div>
                    <div className="award-verified">
                      <span>✓</span>
                      Official Recognition
                    </div>
                  </div>

                  <article className="award-details">
                    {/* <div className="award-count">
                      <span>{String(index + 1).padStart(2, "0")}</span>
                      <i />
                      <small>{String(awards.length).padStart(2, "0")}</small>
                    </div> */}
                    <span className="award-category">{award.category}</span>
                    <h3>{award.title}</h3>
                    <p className="award-organisation">{award.organisation}</p>
                    <p className="award-description">{award.description}</p>

                    <div className="award-meta">
                      <div>
                        <small>Recognition</small>
                        <strong>{award.year}</strong>
                      </div>
                      <div>
                        <small>Presented to</small>
                        <strong>ISBM University</strong>
                      </div>
                    </div>

                    <div className="award-controls">
                      <button
                        type="button"
                        onClick={() => mainSliderRef.current?.slickPrev()}
                        aria-label="Previous award"
                      >
                        ←
                      </button>
                      <button
                        type="button"
                        onClick={() => mainSliderRef.current?.slickNext()}
                        aria-label="Next award"
                      >
                        →
                      </button>
                      <div className="award-progress" aria-hidden="true">
                        <span
                          style={{
                            width: `${((index + 1) / awards.length) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="awards-browser">
          <div className="awards-browser-header">
            <div>
              <span>Explore all recognitions</span>
              <small>Newest awards are displayed first</small>
            </div>
            <div className="awards-browser-controls">
              <button
                type="button"
                onClick={() => browserSliderRef.current?.slickPrev()}
                aria-label="Previous award thumbnails"
              >
                ←
              </button>
              <button
                type="button"
                onClick={() => browserSliderRef.current?.slickNext()}
                aria-label="Next award thumbnails"
              >
                →
              </button>
            </div>
          </div>

          <Slider
            ref={browserSliderRef}
            className="awards-slick-browser"
            {...browserSettings}
          >
            {awards.map((award, index) => (
              <div className="award-browser-slide" key={`${award.title}-nav`}>
                <button
                  type="button"
                  aria-label={`Show ${award.title}`}
                  aria-current={activeAward === index ? "true" : undefined}
                  className={`award-browser-card ${activeAward === index ? "active" : ""
                    }`}
                  onClick={() => openAward(index)}
                >
                  <span className="award-thumbnail-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="award-thumbnail-image">
                    <img src={award.image} alt="" loading="lazy" />
                  </span>
                  <span className="award-thumbnail-copy">
                    <small>{award.year}</small>
                    <strong>{award.title}</strong>
                  </span>
                  <i>↗</i>
                </button>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export { awards };
export default Awards;
